module.exports = __webpack_public_path__ + "static/media/close.6a2164de.svg";